<div class="list-actions">
	<button type="button" class="btn btn-cta btn-icon btn-add" (click)="addContact()"><i class="glyphicon glyphicon-plus"></i> <span>Add contact</span></button>
</div>

<contact-list [source]="model" (onContactSelect)="editContact($event)" (onContactDelete)="deleteContact($event)" (onToggleStatus)="toggleContactStatus($event)"></contact-list>
